export const apiRoutes = {
  login: "login",
  googleLogin: "google-login",
  googleSignup: "google-signup",

  // 2FA Login route
  twoFALogin: "2fa-login",

  // forgot and reset password
  forgotPassword: "forgot-password",
  resetPassword: "reset-password",

  // Admin
  ADMIN_LOGIN: "admin/login",
  GET_TENENT_LIST: "admin/tenents",
  TOGGLE_TENANT_ENABLED: "admin/tenent/toggle",

  // Company
  GET_TIMEZONES: "company/timezones/all",
  GET_COMPANY_LIST: "company",
  UPDATE_COMPANY: "company",
  CREATE_COMPANY: "company",
  DELETE_COMPANY: "company",
  UPDATE_DST: "company/dst",
  DELETE_COMPANY_USER: "company",
  ADD_USER_TO_COMPANY: "company/addUserToCompany",

  // Users
  GET_USERS_LIST: "user",
  GET_ALL_USERS_LIST: "user/all-users",
  GET_PENDING_USERS: "user/pending-users",
  GET_ALL_USER_WITH_CATEGORY: "company/category/all",
  GET_ALL_ACCESS_OF_USER: "user/all-access-pages",
  APPROVE_PENDING_USER: "user/pending/approve",
  REJECT_PENDING_USER: "user/pending/reject",
  CREATE_USER: "user",
  SIGNUP_USER: "signup",
  RESEND_OTP: "resend-otp",
  VERIFY_OTP: "verify-otp",
  UPDATE_USER: "user",
  GET_USER_DETAILS_BY_ID: "user",
  DELETE_USER: "user",
  UPDATE_USER_BY_ID: "user/update-by-id",
  UPDATE_ACTIVE_COMPANY: "user/current-active-company",
  GET_ROLE_CHANGE_REQUESTS: "user/role-requests",
  HANDLE_ROLE_CHANGE_REQUEST: "user/role-requests",
  GET_SCAN_DATA: "/scan-data",

  // Categories
  GET_CATEGOTY_LIST: "category",
  CREATE_CATEGORY: "category",
  UPDATE_CATEGORY: "category",
  DELETE_CATEGORY: "category",
  UPDATE_CATEGORY_CRITERIA: "category/criteria",
  COPY_CATEGORIES: "category/copyCategories",
  REMOVE_USER_FROM_CAT: "category/removeUserForCategory",
  ADD_USER_FROM_CAT: "category/addUserForCategory",
  GET_CATEGORY_COMPANIES: "category/companies",
  GET_INVOICE_LIST: "invoice",
  PAY_INVOICE: "invoice/pay",
  SUBSCRIBE_INVOICE: "invoice/subscribe",
  INVOICE_ALERTS: "invoice/alerts",
  INVOICE_PAYMENT_METHOD: "invoice/payment-method",
  RUN_MONTHLY_BILLING: "invoice/run-monthly-billing",
  GET_SUBSCRIPTION_LIST: "subscription",

  // Power Search
  POWER_SEARCH: "search/power/submit",
  QUICK_SEARCH: "search/quick/submit",

  PASSWORD_RESET: "user/password-reset",
  CHANGE_PASSWORD: "user/change-password",
  GET_MY_IP: "user/my-ip",


  // Security Profile routes
  GET_SECURITY_PROFILE_LIST: 'securityprofile',
  CREATE_SECURITY_PROFILE: 'securityprofile',
  UPDATE_SECURITY_PROFILE: 'securityprofile',
  DELETE_SECURITY_PROFILE: 'securityprofile',

  GET_IP_RULES: 'securityprofile/ip-rules',
  CREATE_IP_RULES: 'securityprofile/ip-rules',
  UPDATE_IP_RULE: 'securityprofile/ip-rules',
  DELETE_IP_RULE: 'securityprofile/ip-rules',

  // Tour routes
  GET_TOURS: "tours",
  COMPLETE_TOUR: "tours/complete",
  RESET_TOURS: "tours/reset",

  // Chatbot
  CHAT: "chat",

  // OCR Feedback
  OCR_FEEDBACK: "desktop-ocr-feedback",
  OCR_CORRECTION: "desktop-ocr-correction",
};
